import {BasicEntity, BasicProperty} from '../../basic-entity-back/annotations';
import {PropertyType} from '../../basic-entity-back/property-type/property-type';
import {ManagerCachingStrategy} from '../../basic-entity-back/basic-entity-interface/mapping-external';
import {Resource} from "../../api/resource";
import {CentroProduccion} from "../centros/centro-produccion.model";
import {ExactSearchFilter} from "../../basic-entity-back/filters/search-filter";
import {MaterialMetodoFabricacionRel} from "./material-metodo-fabricacion-rel.model";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {IRI_PROPERTY, TYPE_PROPERTY} from "../../basic-entity-back/basic-entity-interface/mapping-internal";

@BasicEntity({
    name: 'Metodos de fabricación',
    endpoint: 'metodo_fabricacions',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    acceptsBulkIriSearch: true,
    type: 'MetodoFabricacion',
    managerCaching: ManagerCachingStrategy.PrecacheOnStart,
    modelNameProperty: 'descripcion'
})
export class MetodoFabricacion extends Resource {

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer(),
    })
    private _id;

    @BasicProperty({
        name: 'Método',
        type: PropertyType.String(),
        sortable: true,
        filters: [ExactSearchFilter],
        order: 0
    })
    private _descripcion;

    @BasicProperty({
        name: 'Materiales',
        type: PropertyType.NestedModel(MaterialMetodoFabricacionRel, 'metodoFabricacion', NestedBehavior.CreateOnly, [IRI_PROPERTY, TYPE_PROPERTY, 'orden']),
        array: true,
        order: 4
    })
    private _materiales;

    @BasicProperty({
        name: 'Centros de Producción',
        type: PropertyType.Uri(CentroProduccion),
        array: true
    })
    private _centros: CentroProduccion[]

    @BasicProperty({
        name: 'Se fabrica en disco',
        type: PropertyType.Boolean(),
        order: 2
    })
    private _fabricarEnDisco;

    @BasicProperty({
        name: 'Carpeta por línea al validar',
        ayuda: 'Marcado: al validar, cada línea va a su propia carpeta N-MÉTODO-MATERIAL-ACABADO-COLOR-CLIENTE-PACIENTE, con su STL, su constructionInfo y su observaciones.txt.\n\nSin marcar: disposición anterior (STL suelto o subcarpeta 001, 002… en la carpeta de la tarifa, con HECHO y observaciones.txt comunes).',
        type: PropertyType.Boolean(),
        order: 3
    })
    private _carpetaPorLinea;


    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get descripcion() {
        return this._descripcion;
    }

    set descripcion(value) {

        this._descripcion = value;
    }

    get materiales() {
        return this._materiales;
    }

    set materiales(value) {
        this._materiales = value;
    }

    get centros(): CentroProduccion[] {
        return this._centros;
    }

    set centros(value: CentroProduccion[]) {
        this._centros = value;
    }

    get fabricarEnDisco() {
        return this._fabricarEnDisco;
    }

    set fabricarEnDisco(value) {
        this._fabricarEnDisco = value;
    }

    get carpetaPorLinea() {
        return this._carpetaPorLinea;
    }

    set carpetaPorLinea(value) {
        this._carpetaPorLinea = value;
    }
}

MaterialMetodoFabricacionRel.MAP_METODO.type = CentroProduccion.METODOS_MAP.type = PropertyType.Uri(MetodoFabricacion);
